import React from 'react'

export const RenderEmails = ({emails}) => {
    const result = (
        <div>{emails && emails.map((emailAddress,key) =>
            <p key={key}>
                <a key={key} href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </p>
        )}</div>
    )
    return result
}

export const customModalStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
		top: 'initial',
		bottom: 'initial',
		left: 'initial',
		right: 'initial',
		maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        width: '55%'
    }
}



// WEBPACK FOOTER //
// ./components/outbox/outboxHelpers.jsx